export const isoFormat = 'yyyy-MM-dd\'T\'HH:mm:ssxxx'

/**
 * Takes a Date object, and removes the timezone whilst maintaining the same time.
 * e.g. Date object of: 2025-01-01T12:34:56+02:00 becomes
 * Date object of: 2025-01-01T12:34:56Z
 *
 * This replaces our usage of the moment function utcOffset(0, true)
 *
 * @param date
 * @returns {Date}
 */
export function stripTimezone(date) {
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();
  const milliseconds = date.getUTCMilliseconds();

  return new Date(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds));
}

/**
 * Takes a Date object, and adds the local timezone, whilst maintaining the same date/time.
 * e.g. Date object of: 2025-01-01T23:59:59+00:00,
 * which would display clientside as 2025-01-01T23:59:59+01:00 in BST
 * is converted to 2025-01-01T22:59:59+00:00 in BST (or 2025-01-01T23:59:59+01:00 in BST)
 *
 * This replaces our usage of the moment function utcOffset(0, true)
 *
 * @param date
 * @returns {Date}
 */
export function addTimezoneOffset(date: Date) {
  if (date instanceof Date && !isNaN(date.getTime()) && date.getTimezoneOffset()) {
    date.setHours(date.getHours() + (date.getTimezoneOffset() / 60))
    return date
  }

  return date
}
